<div class="loader-overlay" *ngIf="(loaderService._observer | async)?.isLoading">
  <div class="loader" [ngClass]="(loaderService._observer | async)?.type"></div>
</div>
